import Button from '@mui/material/Button';
import MessageIcon from '@mui/icons-material/Message';

export default function SmsButton({ phoneNumber, bodyText = '', fullWidth = false, label = "Send SMS" }) {
  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      href={`sms:${phoneNumber}${bodyText ? `?body=${encodeURIComponent(bodyText)}` : ''}`}
      startIcon={<MessageIcon />}
      fullWidth={fullWidth}
    >
      {label}
    </Button>
  );
}
